<template>
    <div >
        <draggable
            :value="data"
            @input="data => $emit('input', data)"
            handle=".handle"
            ghost-class="opacity-50"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div class="mb-2 grid gap-2 grid-cols-15 relative" v-for="(row, index) in data" :key="`builder-row-left-${index}-${generateKey()}`">
                <span v-if="data.length > 1"
                    class="col-span-1 handle pr-1 text-gray-400 hover:text-gray-600 cursor-pointer transition duration-150 transform"
                    title="Drag to reorder items">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                    </svg>
                </span>
                <row
                    class="col-span-7"
                    :data="row.leftTable"
                    :casino="casino"
                    :language="language"
                    @input="leftTable => updated(leftTable, index, 'leftTable')"
                ></row>
                <row
                    class="col-span-7"
                    :data="row.rightTable"
                    :casino="casino"
                    :language="language"
                    @input="rightTable => updated(rightTable, index, 'rightTable')"
                ></row>
                <button @click="deleteRow(index)" type="button" class="absolute -right-8 top-1/2 transform -translate-y-1/2 hover:bg-red-500 hover:text-red-100 transition duration-75 bg-red-600 text-white rounded shadow justify-center flex items-center">
                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import Select from '../form/Select.vue'
import siteLanguage from '../../config/siteLanguage'
import {useFroalaStore} from "../../stores/froala";

export default {
  name: "RowBuilder",
  components: {
      Select,
      draggable,
  },
    props:{
        value: {
          type: Array
        },
        casino: {
            type: Object,
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return {
                    iso: siteLanguage.iso.ENGLISH,
                    id: siteLanguage.language.ENGLISH,
                };
            },
        },
    },
    data(){
      return {
        data: this.value,
        froalaStore: useFroalaStore(),
      }
    },
    methods: {
      updated(newValue, index, table){
        this.data[index][table] = newValue;
        this.$emit('input', this.data)
      },
      generateKey(){
       return Math.random().toString().substr(2, 8);
      },
      deleteRow(index){
        this.data.splice(index, 1);
        this.$emit('input', this.data);
      }
    },
    watch: {
      value(newValue){
        this.data = newValue;
      }
    }
}
</script>

<style>

</style>
